import { THEMES } from '../../configs/LayoutConfig';
import {
  ECONOMY_FORMAT_UNIT_BY_CODE,
  UNITS,
} from '../../core/services/Technical/DataFeed/Const';
import {
  getMultiplierByCode,
  getUnitByMultiplier,
} from '../technical/charting/trading-view/helper';
import { BUSDCode } from '../technical/charting/trading-view/indicators/BUSD';
import { ForeignTradingCode } from '../technical/charting/trading-view/indicators/ForeignTrading';
import { formatTextFloat } from './Text';

export const getOverrides = theme => {
  return {
    'mainSeriesProperties.candleStyle.upColor': '#3A9981',
    'mainSeriesProperties.candleStyle.borderUpColor': '#3A9981',
    'mainSeriesProperties.candleStyle.downColor': '#F23645',
    'mainSeriesProperties.candleStyle.borderDownColor': '#F23645',
    // 'mainSeriesProperties.barStyle.upColor': '#3A9981',
    // 'mainSeriesProperties.barStyle.downColor': '#F23645',
    // 'paneProperties.background': theme === THEMES.DARK ? '#1F2329' : '#ffffff',
    'paneProperties.vertGridProperties.color':
      theme === THEMES.DARK
        ? 'rgba(178, 181, 190, 0.06)'
        : 'rgba(178, 181, 190, 0.18)',
    'paneProperties.horzGridProperties.color':
      theme === THEMES.DARK
        ? 'rgba(178, 181, 190, 0.06)'
        : 'rgba(178, 181, 190, 0.18)',
  };
};

export const commonConfig = {
  autosize: true,
  timezone: 'Asia/Bangkok',
  debug: false,
  studies_overrides: {
    'volume.volume.color.0': '#F7525E',
    'volume.volume.color.1': '#27A69A',
    'volume.volume.transparency.0': 50,
    'volume.volume.transparency.1': 50,
    // 'volume.show ma': true,
    // 'volume.volume ma.color': 'rgba(255,156,87, 0)',
  },
  enabled_features: ['countdown'],
  disabled_features: [
    'header_saveload',
    // 'header_screenshot',
    // 'header_fullscreen_button',
    // 'use_localstorage_for_settings',
    // 'display_market_status',
    // 'symbol_search_hot_key',
    // 'show_dialog_on_snapshot_ready',
  ],
  symbol_search_request_delay: 100,
  time_frames: [
    { text: '1d', resolution: '1', title: '1D' },
    { text: '5d', resolution: '5', title: '5D' },
    { text: '1m', resolution: '1D', title: '1M' },
    { text: '3m', resolution: '1D', title: '3M' },
    { text: '1y', resolution: '1D', title: '1Y' },
    { text: '5y', resolution: '1W', title: '5Y' },
  ],
  // custom_css_url: '/charting_library/style.css',
};

export const customConfig = {
  custom_formatters: {
    priceFormatterFactory: (symbolInfo, minTick) => {
      if (symbolInfo === null) {
        return null;
      }

      if (symbolInfo.type === 'Economy') {
        return {
          format: (price, signPositive) => {
            if (
              ECONOMY_FORMAT_UNIT_BY_CODE[symbolInfo.code] === UNITS.TRILLION
            ) {
              return `${(price / 10 ** 12).toFixed(2)}T`;
            }

            if (
              ECONOMY_FORMAT_UNIT_BY_CODE[symbolInfo.code] === UNITS.BILLION
            ) {
              return `${(price / 10 ** 9).toFixed(2)}B`;
            }

            if (
              ECONOMY_FORMAT_UNIT_BY_CODE[symbolInfo.code] === UNITS.MILLION
            ) {
              return `${(price / 10 ** 6).toFixed(2)}M`;
            }

            if (
              ECONOMY_FORMAT_UNIT_BY_CODE[symbolInfo.code] === UNITS.THOUSAND
            ) {
              return `${(price / 10 ** 3).toFixed(2)}K`;
            }

            if (
              ECONOMY_FORMAT_UNIT_BY_CODE[symbolInfo.code] === UNITS.PERCENT
            ) {
              return `${(price * 100).toFixed(2)}%`;
            }

            return price.toFixed(2);
          },
        };
      }
      return null;
    },
    studyFormatterFactory: (format, symbolInfo) => {
      if (format.type === 'price') {
        if (format.indicator === BUSDCode) {
          return {
            format: value => {
              const multiplier = getMultiplierByCode(BUSDCode);
              return `${formatTextFloat(
                value / multiplier,
              )}${getUnitByMultiplier(multiplier)}`;
            },
          };
        }
        return null;
      }

      if (format.type === 'volume') {
        if (format.indicator === ForeignTradingCode) {
          return {
            format: value => {
              const multiplier = getMultiplierByCode(ForeignTradingCode);
              return `${formatTextFloat(
                value / multiplier,
              )}${getUnitByMultiplier(multiplier)}`;
            },
          };
        }
        return null;
      }

      if (format.type === 'percent') {
        return null;
      }

      return null;
    },
  },
};

export const getStudiesOverrides = widget => {
  let volumeStudyId = '';

  widget
    .activeChart()
    .getAllStudies()
    .forEach(x => {
      if (x.name === 'Volume') {
        volumeStudyId = x.id;
      }
    });

  // Study Volume
  if (volumeStudyId) {
    const volume = widget.activeChart().getStudyById(volumeStudyId);
    volume.applyOverrides({
      'volume.color.0': '#F7525E',
      'volume.color.1': '#27A69A',
      'volume.transparency.0': 50,
      'volume.transparency.1': 50,
    });
  }
};
